export default __webpack_public_path__ + "144c8e09a4665a699dc70953473ac8f0.png";